/* eslint-disable no-restricted-syntax */

function transitionEndEventName() {
  const el = document.createElement('span');
  const transitions = {
    transition: 'transitionend',
    OTransition: 'oTransitionEnd',
    MozTransition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
  };
  for (const transition in transitions) {
    if (el.style[transition] !== undefined) {
      return transitions[transition];
    }
  }
  return null;
}

export default transitionEndEventName();



// WEBPACK FOOTER //
// ./src/components/snackbar/transitionEndEventName.js